import React from 'react';
import { Alert, Typography } from '@one-thd/sui-atomic-components';

interface ZeroItemsErrorProps {
  visible: boolean;
}

const ZeroItemsError = React.forwardRef<HTMLDivElement, ZeroItemsErrorProps>(
  ({ visible }, ref) => {
    return (
      <div
        className={visible ? 'sui-mb-4' : ''}
        data-testid="zero-items-error"
        ref={ref}
      >
        {visible && (
          <Alert status="error" size="large">
            <Typography variant="body-base">
              Please select the items you want to return.
            </Typography>
          </Alert>
        )}
      </div>
    );
  },
);

export default ZeroItemsError;
